import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import AppSnackbarProvider from './components/pages/utils/AppSnackbarProvider';
import Router from './components/router/Router';
import { theme, lightPalette, darkPalette } from './theme';
import { completeNotification } from './store/socketSlice';
import { getLocalStorageItem } from './services/localStorageUtils';
import { getLoggedInUser } from './store/userSlice';
import { getLoggedInUserDetail } from './services/userApi';
import { onEvent } from './store/socketConfigSlice';

const App = () => {
  const dispatch = useDispatch();
  const accessToken = getLocalStorageItem('AccessToken');
  const socket = useSelector((state) => state.socketConfig.socket);

  const modeType = useSelector((state) => state.theme.type);

  const dynamicTheme = useMemo(
    () =>
      createTheme({
        ...theme,
        palette: {
          ...theme.palette,
          ...(modeType === 'light' ? lightPalette : darkPalette),
        },
      }),
    [theme, modeType],
  );

  useEffect(() => {
    const { body } = document;
    body.style.filter =
      modeType === 'light' ? 'none' : 'invert(1) hue-rotate(180deg)';
  }, [modeType]);

  useEffect(() => {
    if (socket) {
      dispatch(
        onEvent({
          event: 'response',
          callback: (data) => dispatch(completeNotification(data)),
        }),
      );
    }

    if (accessToken && !socket) {
      const getUserDetail = async () => {
        const loggedInUser = await getLoggedInUserDetail();
        dispatch(getLoggedInUser(loggedInUser));
      };
      getUserDetail();
    }
  }, [socket, dispatch, accessToken]);

  return (
    <ThemeProvider theme={dynamicTheme}>
      <AppSnackbarProvider>
        <CssBaseline />
        <Router />
      </AppSnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
